import React, { useCallback, useMemo } from "react";
import Highlighter from "react-highlight-words";

import TextField from "@material-ui/core/TextField";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import keyBy from "lodash/keyBy";

const filterOptions = createFilterOptions({
  stringify: (option) => `${option.id} ${option.cname} ${option.notes || ""}`,
});

const CompanySelect = ({
  companies,
  value,
  onChange,
  helperText,
  error,
  disableClearable,
  ...props
}) => {
  const companiesById = useMemo(() => keyBy(companies, "id"), [companies]);

  const handleChange = useCallback(
    (e, value, reason) => {
      if (!["select-option", "remove-option", "clear"].includes(reason)) {
        return;
      }

      onChange?.(value.map(({ id }) => id));
    },
    [onChange]
  );

  return (
    <Autocomplete
      fullWidth
      disableClearable={disableClearable}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option.cname || ""}
      multiple={true}
      options={companies || []}
      renderInput={(params) => (
        <TextField
          {...params}
          {...props}
          InputLabelProps={{ shrink: true, ...params.InputLabelProps }}
          error={error}
          helperText={helperText}
          variant="outlined"
        />
      )}
      renderOption={(option, { inputValue, selected }) => (
        <React.Fragment>
          <Checkbox checked={selected} color="primary" />
          <ListItemText
            primary={
              <Highlighter
                searchWords={[inputValue || ""]}
                textToHighlight={option.cname || ""}
              >
                {option.cname || ""}
              </Highlighter>
            }
            secondary={option.notes}
          />
        </React.Fragment>
      )}
      value={(value || []).map((id) => companiesById[id]).filter(Boolean)}
      onChange={handleChange}
    />
  );
};

export default CompanySelect;
